// @flow
import React, { Component, Fragment } from 'react';
import type { Node } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Helmet } from 'react-helmet';

import style from '../../assets/styles/drawer.scss';

type Props = {
  +open?: boolean;
  +handleClickOutside: (e: Event) => void;
  +children?: Node;
  +direction?: 'right' | 'bottom';
};

export default class Drawer extends Component<Props, void> {
  static defaultProps = {
    open: false,
    direction: 'right',
  };

  render() {
    const { children, open, handleClickOutside, direction } = this.props;
    return (
      <Fragment>
        {open && <Helmet key="helmet">
          <style type="text/css">{`
          body {
              overflow: hidden!important;
          }
      `}</style>
        </Helmet>}
        <section key="drawerWrap"
                 className={classNames(style.drawerWrap, { [style.open]: open })}>
          <section onClick={handleClickOutside} className={style.veil}/>
          <aside className={classNames({ [style.right]: direction === 'right' },
            { [style.bottom]: direction === 'bottom' })}>
            {children}
          </aside>
        </section>
      </Fragment>);
  }
}

Drawer.propTypes = {
  open: PropTypes.bool,
  handleClickOutside: PropTypes.func.isRequired,
  direction: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/elements/Drawer/Drawer.jsx